module.exports = __webpack_public_path__ + "img/icon_net_logo232.ff1c329a.png";